<template>
  <div class="banner-container" :style="{ backgroundColor: transportMode.color }">
    <span class="icon-container">
      <i v-if="transportMode.icon === 'walking'" class="material-icons">directions_walk</i>
      <i v-else :class="[`icon-${transportMode.icon}`]" />
    </span>
    <span class="study-name">{{ name }}</span>
    <span v-if="site" class="site-name">{{ site.name }}</span>
  </div>
</template>

<script>
export default {
  props: ['data', 'name', 'site'],

  computed: {
    transportMode() {
      return this.data.transportMode;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/A4.scss';
.banner-container {
  height: 31px * A4.$ratio;
  display: flex;
  align-items: center;
  color: white;
  box-sizing: border-box;
  padding: 0 96px;

  .icon-container {
    width: 16px * A4.$ratio;
    height: 16px * A4.$ratio;
    padding-right: 10px;
    margin-right: 32px * A4.$ratio;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid white;
    i {
      font-size: 1.5em;
    }
  }
  .study-name {
    font-size: 18px * A4.$ratio;
  }
  .site-name {
    font-size: 18px;
    margin: 0 0 0 auto;
  }
}
</style>
